import posthog from 'posthog-js'

export default defineNuxtPlugin({
  name: 'posthog',
  parallel: true,
  setup(nuxtApp) {
    const vueApp = nuxtApp.vueApp
    const config = useRuntimeConfig()

    const posthogClient = posthog.init(config.public.posthogPublicKey, {
      api_host: config.public.posthogHost,
      ui_host: config.public.posthogUiHost,
      person_profiles: 'identified_only',
      capture_pageview: false,
      autocapture: false,
      loaded: (posthog) => {
        if (import.meta.env.MODE === 'development') posthog.debug()
      },
      before_send: (event) => {
        if (!event) return null
        event.properties.app = 'rackplanner_frontend'
        return event
      }
    })

    const router = useRouter()
    router.afterEach((to) => {
      nextTick(() => {
        posthog.capture('$pageview', { current_url: to.fullPath })
      })
    })

    return {
      provide: {
        posthog: () => posthogClient
      }
    }
  }
})
